module.exports = __webpack_public_path__ + "img/macs.1859d171.png";